export const GoogleIndexingStatus = Object.freeze({
    success: Symbol('success'),
    new: Symbol('new'),
    limit_reached: Symbol('limit_reached'),
    error: Symbol('error'),
});

export function getStatusText(status) {
    return {
        [GoogleIndexingStatus.new]: 'Nowe',
        [GoogleIndexingStatus.success]: 'Przetworzone',
        [GoogleIndexingStatus.limit_reached]: 'Wyczerpany limit',
        [GoogleIndexingStatus.error]: 'Błąd',
    }[GoogleIndexingStatus[status]];
}
